import React from 'react';
import HeroSection from 'src/components/global/HeroSection';
import ProductItem from 'src/components/global/ProductItem';

const WorldWideShopsView = () => {
  return (
    <>
      <HeroSection pageTitle={'WorldWide Gunbot Shops'} uris={['Shops', 'WorldWide Shops']} />

      <div className="page-content">
        <section style={{ backgroundColor: 'rgba(255, 215, 37, 0.02)' }}>
          <div className="container">
            <div className="row mt-5">
              <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                <ProductItem
                  external={true}
                  link="https://gunbot.shop"
                  name="gunbot.shop"
				          link2="https://gunbot.es"
                  name2="gunbot.es"
                  img="/images/product/gunbotshop.png"
                  author={{
                    name: '@AitorRuiz',
                    avatar: '/images/author-avatar/aitor.jpeg',
                    link: 'https://t.me/AitorRuiz',
                  }}
                  price="Manager / Reseller"
                  unit="Current role"
                  favor="🇪🇸🇻🇳🇬🇧🇵🇹"
                  btnText="Website"
                />
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6 col-12 mt-5 mt-md-0">
                <ProductItem
                  external={true}
                  link="https://gunbot.com"
                  name="gunbot.com"
                  img="/images/product/gunbotcom.png"
                  author={{
                    name: '@boekenbox',
                    avatar: '/images/author-avatar/cat.jpg',
                    link: 'https://t.me/boekenbox',
                  }}
                  price="Core Dev/Reseller"
                  unit="Current role"
                  favor="🇳🇱🇬🇧🇩🇪"
                  btnText="Website"
                />
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6 col-12 mt-5 mt-xl-0">
                <ProductItem
                  external={true}
                  link="https://shop.gunthy.es/en/"
                  name="gunthy.es"
                  img="/images/product/gunthyes.png"
                  author={{
                    name: '@crazymop',
                    avatar: '/images/author-avatar/uri.jpg',
                    link: 'https://t.me/crazymop',
                  }}
                  price="Gunbot School/Reseller"
                  unit="Current role"
                  favor="🇪🇸🇬🇧"
                  btnText="Website"
                />
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                <ProductItem
                  external={true}
                  link="https://gunbot.store"
                  name="gunbot.store"
				          link2="https://gunbot-crypto.com"
                  name2="gb4cryptocom"
                  img="/images/product/cdt.png"
                  author={{
                    name: '@CDT',
                    avatar: '/images/author-avatar/cdt.jpeg',
                    link: 'https://t.me/Cryptodailytradingofficial',
                  }}
                  price="Gunthy Biz Dev/Reseller"
                  unit="Current role"
                  favor="🇳🇱🇬🇧🇩🇪🇫🇷"
                  btnText="Website"
                />
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6 col-12 mt-5">
                <ProductItem
                  external={true}
                  link="https://gunbot.vip"
                  name="gunbot.vip"
                  img="/images/product/dob.png"
                  author={{
                    name: '@dobcrypto',
                    avatar: '/images/author-avatar/dob.png',
                    link: 'https://t.me/dobcrypto',
                  }}
                  price="Reseller"
                  unit="Current role"
                  favor="🇷🇺🇬🇧"
                  btnText="Website"
                />
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6 col-12 mt-5">
                <ProductItem
                  external={true}
                  link="https://gunbot.ph/"
                  name="gunbot.ph"
                  img="/images/product/ph.png"
                  author={{
                    name: '@Crwth',
                    avatar: '/images/author-avatar/ph.jpeg',
                    link: 'https://t.me/Crwth',
                  }}
                  price="Reseller"
                  unit="Current role"
                  favor="🇬🇧🇵🇭"
                  btnText="Website"
                />
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6 col-12 mt-5">
                <ProductItem
                  external={true}
                  link="https://broxynet.com/"
                  name="broxynet"
                  img="/images/product/broxy.png"
                  author={{
                    name: '@Steven0_0smith',
                    avatar: '/images/author-avatar/broxy.jpeg',
                    link: 'https://t.me/Steven0_0smith',
                  }}
                  price="Reseller"
                  unit="Current role"
                  favor="🇬🇧"
                  btnText="Website"
                />
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6 col-12 mt-5">
                <ProductItem
                  external={true}
                  link="https://gunbot.co.nz/"
                  name="gunbot.co.nz"
                  img="/images/product/kaka.png"
                  author={{
                    name: '@KakaOne',
                    avatar: '/images/author-avatar/kaka.jpeg',
                    link: 'https://t.me/KakaOne',
                  }}
                  price="Reseller"
                  unit="Current role"
                  favor="🇬🇧"
                  btnText="Website"
                />
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6 col-12 mt-5">
                <ProductItem
                  external={true}
                  link="https://t.me/rivelsrud"
                  name="Siggen(GSR)"
                  img="/images/product/rivelsrud.jpeg"
                  author={{
                    name: '@rivelsrud',
                    avatar: '/images/author-avatar/rivelsrud.png',
                    link: 'https://t.me/rivelsrud',
                  }}
                  price="Reseller"
                  unit="Current role"
                  favor="🇩🇰🇳🇴🇸🇪🇬🇧"
                  btnText="Telegram"
                />
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6 col-12 mt-5">
                <ProductItem
                  external={true}
                  link="https://t.me/nickfury87"
                  name="Nick Ianez"
                  img="/images/product/nick.jpg"
                  author={{
                    name: '@nickfury87',
                    avatar: '/images/author-avatar/nick.jpg',
                    link: 'https://t.me/+X_bKxJkuz-w5M2Ix',
                  }}
                  price="Reseller"
                  unit="Current role"
                  favor="🇬🇧"
                  btnText="Telegram"
                />
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6 col-12 mt-5">
                <ProductItem
                  external={true}
                  link="https://t.me/bit_Ben"
                  name="Bitben"
                  img="/images/product/bitben.jpg"
                  author={{
                    name: '@bit_Ben',
                    avatar: '/images/author-avatar/bitben.jpg',
                    link: 'https://t.me/bit_Ben',
                  }}
                  price="Reseller"
                  unit="Current role"
                  favor="🇩🇪🇬🇧"
                  btnText="Telegram"
                />
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6 col-12 mt-5">
                <ProductItem
                  external={true}
                  link="https://computerguy.com.sg"
                  name="Bitben"
                  img="/images/product/randomag.png"
                  author={{
                    name: '@randomangmoh',
                    avatar: '/images/author-avatar/randomag.png',
                    link: 'https://t.me/randomangmoh',
                  }}
                  price="Reseller"
                  unit="Current role"
                  favor="🇬🇧"
                  btnText="Telegram"
                />
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6 col-12 mt-5">
                <ProductItem
                  external={true}
                  link="https://gunbot.net"
                  name="Luis Gandara"
                  img="/images/product/luis.jpeg"
                  author={{
                    name: '@luis_gandara',
                    avatar: '/images/author-avatar/luis.jpeg',
                    link: 'https://t.me/@luis_gandara',
                  }}
                  price="Reseller"
                  unit="Current role"
                  favor="🇬🇧"
                  btnText="Telegram"
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default WorldWideShopsView;
